/**
 * Strategies that will be used for the ways the MessageWindow can appear on the page (animation)
 * 
 * @author Vladimir Dosen <vlada.dosen@gmail.com>
 * 
 * @param {Object} wind
 * @returns {DefaultStrategy}
 */


var DefaultStrategy = function(wind) {
    var window = wind;
    this.setWindow = function(w) {
        window = w;
        return this;
    };
    this.getWindow = function() {
        return window;
    };
    this.show = function(callback){return this.getWindow();};
    this.hide = function(callback){return this.getWindow();};
};


var DisplayStrategy = function(wind, show_speed, hide_speed) {
    DisplayStrategy.prototype.parent.call(this, wind);
    var showing_speed = show_speed;
    var hiding_speed = hide_speed;
    this.getShowSpeed = function() {
        return showing_speed;
    };
    this.getHideSpeed = function() {
        return hiding_speed;
    };
    this.show = function(callback) {
        this.getWindow().getElement().show(typeof this.getShowSpeed() !== "undefined" ? this.getShowSpeed() : 'fast', typeof callback !== "undefined" ? callback : function(){});
        return this.getWindow();
    };
    this.hide = function(callback) {
        this.getWindow().getElement().hide(typeof this.getHideSpeed() !== "undefined" ? this.getHideSpeed() : 'fast', typeof callback !== "undefined" ? callback : function(){});
        return this.getWindow();
    };
};
DisplayStrategy.prototype              = new DefaultStrategy();
DisplayStrategy.prototype.parent       = DefaultStrategy;
DisplayStrategy.prototype.constructor  = DisplayStrategy;

var AnimateStrategy = function(wind, params) {
    AnimateStrategy.prototype.parent.call(this, wind);
    var parameters = params;
    this.getParameters = function() {
        return parameters;
    };
    this.show = function(callback) {
        this.getWindow().getElement().animate(this.getParameters().show.css,this.getParameters().show.duration,function(){
            if(callback) {
                callback();
            }
        });
        return this.getWindow();
    };
    this.hide = function(callback) {
        this.getWindow().getElement().animate(this.getParameters().hide.css,this.getParameters().hide.duration,function(){
            if(callback) {
                callback();
            }
        });
        return this.getWindow();
    };
};
AnimateStrategy.prototype              = new DefaultStrategy();
AnimateStrategy.prototype.parent       = DefaultStrategy;
AnimateStrategy.prototype.constructor  = AnimateStrategy;